<script setup lang="ts">
    interface Props {
        duration?: {
            enter?: string;
            leave?: string;
        };
    }

    const props = withDefaults(defineProps<Props>(), {
        duration: () => ({
            enter: 'duration-100',
            leave: 'duration-75',
        }),
    });
</script>

<template>
    <Transition
        :enter-active-class="`transition ease-out ${duration.enter}`"
        enter-from-class="transform opacity-0 translate-y-2"
        enter-to-class="transform opacity-100 translate-y-0"
        :leave-active-class="`transition ease-in ${duration.leave}`"
        leave-from-class="transform opacity-100 translate-y-0"
        leave-to-class="transform opacity-0 translate-y-2"
    >
        <slot></slot
    ></Transition>
</template>
